<div class="flex w-full cursor-pointer flex-col justify-center gap-2 pt-2">
  <div class="flex w-full items-center justify-center">
    <div class="group relative z-[3]">
      @if (behandlerAssignmentData()) {
        @if (behandlerAssignmentData()?.behandlerIndex) {
          <div class="behandler-id">
            {{ behandlerAssignmentData()?.behandlerDisplayId }}
          </div>
        } @else {
          <div class="behandler-id behandler-skipped">
            <img [ngSrc]="'@shared/rounded-rectangle.svg'" alt="" width="18" height="4" />
          </div>
        }
      }

      @if (pageImageService.isThumbnailImageLoaded(typeThumbnail().id)()) {
        <img
          [src]="pageImageService.getThumbnailImageSrc(typeThumbnail().id)()"
          [alt]="typeThumbnail()"
          loading="lazy"
          class="relative z-[3] h-full rounded-md border-[3px] bg-white object-contain"
          [ngClass]="selected() ? 'border-theme-blue' : 'border-theme-gray-400'" />
      } @else {
        <p-progress-spinner class="flex aspect-[0.7/1] items-center justify-center" />
      }
      <div
        class="border-theme-gray-400 absolute -top-1 left-1 z-[2] h-full w-full rounded-md border-[3px] bg-white px-1 opacity-60"></div>
      <div
        class="border-theme-gray-400 absolute -top-2 left-2 z-[1] h-full w-full rounded-md border-[3px] bg-white px-1 opacity-30"></div>
      @if (documentThumbnailOverlayTemplate()) {
        <ng-container
          [ngTemplateOutlet]="documentThumbnailOverlayTemplate()!"
          [ngTemplateOutletContext]="{ $implicit: document() }"></ng-container>
      }
    </div>
  </div>
  <div
    class="flex max-w-full flex-col items-center justify-center gap-1.5 rounded-[9px] p-1.5 text-wrap"
    [ngClass]="selected() ? 'bg-theme-blue' : 'bg-theme-gray-400'">
    @if (documentLabelTemplate()) {
      <ng-container
        [ngTemplateOutlet]="documentLabelTemplate()!"
        [ngTemplateOutletContext]="{ $implicit: document() }"></ng-container>
    } @else {
      <div class="grid w-full grid-cols-[auto_minmax(0,1fr)] items-center gap-2">
        @for (documentClass of document().documentClasses; track documentClass) {
          @if (documentClass !== 'UNBEKANNT') {
            <img
              #img
              (error)="img.src = '@shared/document-class/monkey.svg'"
              class="h-4 w-4"
              loading="lazy"
              [src]="`@shared/document-class/${documentClass}.svg`"
              [ngClass]="selected() ? 'brightness-[100]' : ''"
              [alt]="documentClass" />
          }
          <span
            #labelElement
            class="text-xxs h-4 whitespace-nowrap"
            [class.col-span-2]="documentClass === 'UNBEKANNT'"
            [class.text-center]="documentClass === 'UNBEKANNT'"
            [ngClass]="selected() ? 'font-bold text-white' : 'text-black'"
            sharedCoreTooltipOnContentOverflow
            [displayedValue]="documentClass | classLabel">
            {{ documentClass | classLabel }}
          </span>
        }
      </div>
    }
  </div>
</div>
